import PropTypes from 'prop-types';
import SelectLanguages from './SelectLanguages';
import CustomLink from './CustomLink';

function LoginLink({ pathData, t }) {
  return (
    <div className="flex items-center gap-4 max-[650px]:hidden">
      <SelectLanguages t={t} />
      <CustomLink
        id="link-login"
        className="relative font-bold after:absolute after:bottom-[-2px] after:left-1/2 after:right-1/2 after:h-0.5 after:bg-white after:transition-all hover:after:left-0 hover:after:right-0"
        href="/login"
        name={t('link.login')}
      />
    </div>
  );
}

LoginLink.propTypes = {
  pathData: PropTypes.shape({ url: PropTypes.string }).isRequired,
  t: PropTypes.func.isRequired,
};

export default LoginLink;
